import { useQuery } from "@tanstack/react-query";
import { getSkills } from "../../api/apiSkills";
import i18next from "i18next";

/**
 * Hook لجلب قائمة المهارات المفلترة
 * @param {Object} params - Query parameters (page, per_page, search, trashed)
 */
export function useGetSkills(params = {}) {
    const {
        isLoading,
        data,
        error,
        refetch,
    } = useQuery({
        queryKey: ["skills", params, i18next.language],
        queryFn: () => getSkills(params),
        retry: false,
    });

    const skills = data?.data || [];
    const meta = data?.meta || { current_page: 1, per_page: params.per_page || 15, total: 0 };

    return { isLoading, error, skills, meta, refetch };
}